"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

var _ = require("../");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var BREADCRUMB_LINK_COLOR = "var(--breadcrumbs-link-color)";

var Breadcrumbs = /*#__PURE__*/function (_Component) {
  _inherits(Breadcrumbs, _Component);

  var _super = _createSuper(Breadcrumbs);

  function Breadcrumbs() {
    _classCallCheck(this, Breadcrumbs);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumbs, [{
    key: "render",
    value: function render() {
      var _this = this;

      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);
      var breadcrumbs = this.props.children.map(function (child, idx, allChildren) {
        var modifiedChild = /*#__PURE__*/(0, _react.cloneElement)(child, {
          isCurrent: idx === allChildren.length - 1,
          size: _this.props.size
        });
        return modifiedChild;
      });

      var separator = /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(this.constructor.BASE_CLASS, "__separator")
      }, /*#__PURE__*/_react.default.createElement(_.Text, {
        size: this.props.size
      }, "/"));

      var placeholders = _toConsumableArray(new Array(breadcrumbs.length * 2 - 1));

      var content = placeholders.map(function (_obj, index) {
        return index % 2 === 0 ? breadcrumbs[index / 2] : separator;
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getStyle(),
        className: this.getClassNames()
      }, content);
    }
  }]);

  return Breadcrumbs;
}(_component.default);
/*---------------------------------------------*/


exports.default = Breadcrumbs;

_defineProperty(Breadcrumbs, "BASE_CLASS", "lth-c-breadcrumbs");

Breadcrumbs.Item = function BreadcrumbItem(props) {
  var isCurrent = props.isCurrent,
      children = props.children;
  var LinkOrText = isCurrent ? _.Text : _.Link;
  var optionalStyle = {};

  if (!props.disabled && !isCurrent) {
    optionalStyle.color = BREADCRUMB_LINK_COLOR;
  }

  return /*#__PURE__*/_react.default.createElement(LinkOrText, _extends({}, props, {
    style: optionalStyle
  }), children);
};
/*---------------------------------------------*/


Breadcrumbs.METADATA = {
  name: "Breadcrumbs",
  props: [{
    name: "crumbs",
    type: "array",
    category: "value"
  }, {
    name: "size",
    type: "string",
    default: "regular",
    options: [{
      value: "small",
      label: "Small"
    }, {
      value: "regular",
      label: "Regular"
    }]
  }],
  content: {
    default: [/*#__PURE__*/_react.default.createElement(Breadcrumbs.Item, {
      href: "https://www.site.com"
    }, "Home"), /*#__PURE__*/_react.default.createElement(Breadcrumbs.Item, {
      href: "https://www.site.com/category"
    }, "Category"), /*#__PURE__*/_react.default.createElement(Breadcrumbs.Item, {
      disabled: true,
      href: "https://www.site.com/category"
    }, "Disabled Category"), /*#__PURE__*/_react.default.createElement(Breadcrumbs.Item, {
      href: "https://www.site.com/category/page"
    }, "Current Page")]
  }
};